/**
 * PMGW Custom JavaScript - Gustoso
 * Dynamic Shipping Calculation by Country
 * Supports both price-based and weight-based shipping rules
 */

(function() {
  'use strict';

  var shippingCalculator = null;

  // Wait for theme to be ready
  document.addEventListener('DOMContentLoaded', function() {
    initShippingCalculator();
  });

  function initShippingCalculator() {
    shippingCalculator = new ShippingCalculator();
    shippingCalculator.init();
  }

  function ShippingCalculator() {
    this.lastSubtotal = null;
    this.lastWeight = null;
    this.pollingInterval = null;
    
    // Shipping rules by country
    // price-based: uses cart total in cents
    // weight-based: uses cart weight in kg
    this.shippingRules = {
      // === DEUTSCHLAND (DE) - Preisbasiert ===
      'DE': {
        type: 'price',
        freeThreshold: 10000,
        tiers: [
          { maxPrice: 2999, shipping: 995 },
          { maxPrice: 9999, shipping: 595 },
          { maxPrice: Infinity, shipping: 0 }
        ]
      },
      // === ÖSTERREICH (AT) - Preisbasiert ===
      'AT': {
        type: 'price',
        freeThreshold: 20001,
        tiers: [
          { maxPrice: 9999, shipping: 1495 },
          { maxPrice: 20000, shipping: 995 },
          { maxPrice: Infinity, shipping: 0 }
        ]
      },
      // === BELGIEN (BE) - Gewichtsbasiert ===
      'BE': {
        type: 'weight',
        freeThreshold: Infinity,
        tiers: [
          { maxWeight: 8.99, shipping: 1495 },
          { maxWeight: 19.99, shipping: 1995 },
          { maxWeight: 31.99, shipping: 2295 },
          { maxWeight: Infinity, shipping: 2595 }
        ]
      },
      // === DÄNEMARK (DK) - Gewichtsbasiert ===
      'DK': {
        type: 'weight',
        freeThreshold: Infinity,
        tiers: [
          { maxWeight: 8.99, shipping: 1995 },
          { maxWeight: 19.99, shipping: 2595 },
          { maxWeight: 31.99, shipping: 2895 },
          { maxWeight: Infinity, shipping: 3295 }
        ]
      },
      // === IRLAND (IE) - Gewichtsbasiert ===
      'IE': {
        type: 'weight',
        freeThreshold: Infinity,
        tiers: [
          { maxWeight: 8.99, shipping: 2300 },
          { maxWeight: 19.99, shipping: 3000 },
          { maxWeight: 31.99, shipping: 4000 },
          { maxWeight: 39.99, shipping: 4800 },
          { maxWeight: Infinity, shipping: 5800 }
        ]
      },
      // === LIECHTENSTEIN (LI) - Gewichtsbasiert ===
      'LI': {
        type: 'weight',
        freeThreshold: Infinity,
        tiers: [
          { maxWeight: 8.99, shipping: 1800 },
          { maxWeight: 19.99, shipping: 2700 },
          { maxWeight: 31.99, shipping: 4200 },
          { maxWeight: 39.99, shipping: 5300 },
          { maxWeight: Infinity, shipping: 6000 }
        ]
      },
      // === LUXEMBURG (LU) - Gewichtsbasiert ===
      'LU': {
        type: 'weight',
        freeThreshold: Infinity,
        tiers: [
          { maxWeight: 8.99, shipping: 1495 },
          { maxWeight: 19.99, shipping: 1995 },
          { maxWeight: 31.99, shipping: 2295 },
          { maxWeight: Infinity, shipping: 2595 }
        ]
      },
      // === NIEDERLANDE (NL) - Gewichtsbasiert ===
      'NL': {
        type: 'weight',
        freeThreshold: Infinity,
        tiers: [
          { maxWeight: 8.99, shipping: 1495 },
          { maxWeight: 19.99, shipping: 1995 },
          { maxWeight: 31.99, shipping: 2295 },
          { maxWeight: Infinity, shipping: 2595 }
        ]
      },
      // === SCHWEIZ (CH) - Gewichtsbasiert ===
      'CH': {
        type: 'weight',
        freeThreshold: Infinity,
        tiers: [
          { maxWeight: 8.99, shipping: 6000 },
          { maxWeight: 19.99, shipping: 7500 },
          { maxWeight: 31.99, shipping: 9500 },
          { maxWeight: 39.99, shipping: 13000 },
          { maxWeight: Infinity, shipping: 16500 }
        ]
      },
      // === FRANKREICH (FR) - Gewichtsbasiert ===
      'FR': {
        type: 'weight',
        freeThreshold: Infinity,
        tiers: [
          { maxWeight: 8.99, shipping: 1995 },
          { maxWeight: 19.99, shipping: 2495 },
          { maxWeight: 31.99, shipping: 3495 },
          { maxWeight: Infinity, shipping: 3895 }
        ]
      },
      // === ITALIEN (IT) - Gewichtsbasiert ===
      'IT': {
        type: 'weight',
        freeThreshold: Infinity,
        tiers: [
          { maxWeight: 8.99, shipping: 1995 },
          { maxWeight: 19.99, shipping: 2495 },
          { maxWeight: 31.99, shipping: 3495 },
          { maxWeight: Infinity, shipping: 3895 }
        ]
      },
      // === ANDORRA (AD) - Gewichtsbasiert ===
      'AD': {
        type: 'weight',
        freeThreshold: Infinity,
        tiers: [
          { maxWeight: 8.99, shipping: 1995 },
          { maxWeight: 19.99, shipping: 2495 },
          { maxWeight: 31.99, shipping: 3495 },
          { maxWeight: Infinity, shipping: 3895 }
        ]
      },
      // === FINNLAND (FI) - Gewichtsbasiert ===
      'FI': {
        type: 'weight',
        freeThreshold: Infinity,
        tiers: [
          { maxWeight: 8.99, shipping: 1995 },
          { maxWeight: 19.99, shipping: 2495 },
          { maxWeight: 31.99, shipping: 3495 },
          { maxWeight: Infinity, shipping: 3895 }
        ]
      }
    };
    
    // Default rules (same as DE)
    this.defaultRules = {
      type: 'price',
      freeThreshold: 10000,
      tiers: [
        { maxPrice: 2999, shipping: 995 },
        { maxPrice: 9999, shipping: 595 },
        { maxPrice: Infinity, shipping: 0 }
      ]
    };
  }

  ShippingCalculator.prototype = {
    init: function() {
      this.fetchCartAndUpdate();
      this.listenToCartEvents();
    },

    listenToCartEvents: function() {
      var self = this;
      
      // Listen for cart:updated event (triggered by theme after cart changes)
      document.addEventListener('cart:updated', function(evt) {
        var cart = evt.detail && evt.detail.cart;
        if (cart) {
          self.updateFromCartData(cart);
        } else {
          self.fetchCartAndUpdate();
        }
      });

      // Also listen for cart:build as backup
      document.addEventListener('cart:build', function() {
        setTimeout(function() {
          self.fetchCartAndUpdate();
        }, 300);
      });

      // Listen for drawer open
      document.addEventListener('drawerOpen', function() {
        setTimeout(function() {
          self.fetchCartAndUpdate();
        }, 150);
      });

      // Listen for quantity changes (Impulse theme uses cart:quantity)
      document.addEventListener('cart:quantity', function() {
        setTimeout(function() {
          self.fetchCartAndUpdate();
        }, 400);
      });

      // Listen for ajaxProduct:added (when product is added to cart)
      document.addEventListener('ajaxProduct:added', function() {
        setTimeout(function() {
          self.fetchCartAndUpdate();
        }, 300);
      });

      // Observe DOM changes to cart drawer for fallback
      this.observeCartChanges();
    },

    observeCartChanges: function() {
      var self = this;
      var cartDrawer = document.querySelector('#CartDrawer');
      
      if (cartDrawer && typeof MutationObserver !== 'undefined') {
        var observer = new MutationObserver(function(mutations) {
          try {
            // Check if cart items changed
            var hasRelevantChange = mutations.some(function(mutation) {
              if (mutation.type !== 'childList') return false;
              var target = mutation.target;
              // Make sure target is an element before calling matches
              if (!target || !target.matches) return false;
              return target.matches('[data-products]') || target.closest('[data-products]');
            });
            
            if (hasRelevantChange) {
              setTimeout(function() {
                self.fetchCartAndUpdate();
              }, 200);
            }
          } catch (e) {
            // Silently ignore errors to not break other scripts
          }
        });
        
        observer.observe(cartDrawer, {
          childList: true,
          subtree: true
        });
      }
    },

    fetchCartAndUpdate: function() {
      // Fetch cart data directly from Shopify API
      fetch('/cart.js')
        .then(function(response) { return response.json(); })
        .then(function(cart) {
          this.updateFromCartData(cart);
        }.bind(this))
        .catch(function(error) {
          console.error('Error fetching cart:', error);
        });
    },

    forceUpdate: function() {
      this.fetchCartAndUpdate();
    },

    updateFromCartData: function(cart) {
      if (cart && typeof cart.total_price !== 'undefined') {
        this.lastSubtotal = cart.total_price;
        this.lastWeight = cart.total_weight ? cart.total_weight / 1000 : 0;
        this.updateShippingCostsWithData(cart.total_price, this.lastWeight);
      }
    },

    getCartData: function() {
      var shippingContainer = document.querySelector('#shippingAndTotal');
      var subtotal = null;
      var weight = 0;
      
      // First try to get from data attributes (most accurate, set by Liquid)
      if (shippingContainer && shippingContainer.dataset.cartTotalCents) {
        subtotal = parseInt(shippingContainer.dataset.cartTotalCents);
      }
      
      if (shippingContainer && shippingContainer.dataset.cartWeight) {
        weight = parseFloat(shippingContainer.dataset.cartWeight);
      }

      // Fallback: Try to get from theme's subtotal element
      if (subtotal === null) {
        var themeSubtotal = document.querySelector('[data-subtotal]');
        if (themeSubtotal) {
          var subtotalText = themeSubtotal.textContent;
          var match = subtotalText.match(/[\d.,]+/);
          if (match) {
            // Handle European format (1.234,56) and standard format (1,234.56)
            var numStr = match[0];
            // If it has both . and , we need to determine the format
            if (numStr.indexOf(',') > numStr.indexOf('.')) {
              // European format: 1.234,56 -> 1234.56
              numStr = numStr.replace(/\./g, '').replace(',', '.');
            } else if (numStr.indexOf('.') > numStr.indexOf(',')) {
              // Standard format: 1,234.56 -> 1234.56
              numStr = numStr.replace(/,/g, '');
            } else if (numStr.indexOf(',') !== -1) {
              // Only comma, European: 12,34 -> 12.34
              numStr = numStr.replace(',', '.');
            }
            subtotal = Math.round(parseFloat(numStr) * 100);
          }
        }
      }

      if (subtotal !== null) {
        return { subtotal: subtotal, weight: weight };
      }

      return null;
    },

    getCountryCode: function() {
      var shippingContainer = document.querySelector('#shippingAndTotal');
      if (shippingContainer && shippingContainer.dataset.countryCode) {
        return shippingContainer.dataset.countryCode.toUpperCase();
      }
      return 'DE'; // Default
    },

    calculateShipping: function(subtotalCents, weightKg, countryCode) {
      var rules = this.shippingRules[countryCode] || this.defaultRules;
      
      if (rules.type === 'price') {
        // Price-based shipping
        for (var i = 0; i < rules.tiers.length; i++) {
          if (subtotalCents <= rules.tiers[i].maxPrice) {
            return rules.tiers[i].shipping;
          }
        }
      } else if (rules.type === 'weight') {
        // Weight-based shipping
        for (var j = 0; j < rules.tiers.length; j++) {
          if (weightKg <= rules.tiers[j].maxWeight) {
            return rules.tiers[j].shipping;
          }
        }
      }
      
      // Fallback
      return rules.tiers[rules.tiers.length - 1].shipping;
    },

    updateShippingCosts: function() {
      var cartData = this.getCartData();
      if (!cartData) return;
      
      this.updateShippingCostsWithData(cartData.subtotal, cartData.weight);
    },

    updateShippingCostsWithData: function(subtotalCents, weightKg) {
      var shippingContainer = document.querySelector('#shippingAndTotal');
      if (!shippingContainer) return;

      var subtotalElement = shippingContainer.querySelector('[data-cart-subtotal]');
      var shippingElement = shippingContainer.querySelector('[data-shipping-cost]');
      var totalElement = shippingContainer.querySelector('[data-cart-total]');

      if (!subtotalElement || !shippingElement || !totalElement) return;

      var countryCode = this.getCountryCode();
      var shippingCost = this.calculateShipping(subtotalCents, weightKg, countryCode);
      var isFreeShipping = shippingCost === 0;
      var totalCost = subtotalCents + shippingCost;

      // Update subtotal
      subtotalElement.textContent = this.formatMoney(subtotalCents);

      // Update shipping cost display
      if (isFreeShipping) {
        shippingElement.innerHTML = '<span class="HighlightText">Kostenlos</span>';
      } else {
        shippingElement.textContent = this.formatMoney(shippingCost);
      }

      // Update total
      totalElement.textContent = this.formatMoney(totalCost);
    },

    formatMoney: function(cents) {
      // Use theme's currency formatting if available
      if (typeof theme !== 'undefined' && theme.Currency && theme.Currency.formatMoney) {
        return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      }
      // Fallback formatting with European format
      var amount = (cents / 100).toFixed(2);
      return amount.replace('.', ',') + ' €';
    }
  };

  // Make it globally accessible for manual updates
  window.pmgwShippingCalculator = shippingCalculator;
  
  // Expose a simple update function
  window.updateShippingInfo = function() {
    if (shippingCalculator) {
      shippingCalculator.forceUpdate();
    }
  };

})();

// Free shipping bar updater for cart drawer
(function() {
  'use strict';

  function formatMoney(cents) {
    if (typeof theme !== 'undefined' && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }

    var amount = (cents / 100).toFixed(2);
    return amount.replace('.', ',') + ' €';
  }

  function updateBarFromCart(cart) {
    var bar = document.getElementById('CartFreeShippingBar');
    if (!bar || !cart || !Array.isArray(cart.items)) return;

    var threshold = parseInt(bar.dataset.threshold, 10);
    if (!threshold || threshold <= 0) return;

    var requiresShippingTotal = cart.items
      .filter(function(item) { return item.requires_shipping; })
      .reduce(function(sum, item) { return sum + item.final_line_price; }, 0);

    var progress = Math.min(requiresShippingTotal / threshold, 1);
    var isFreeShipping = requiresShippingTotal >= threshold;

    var progressInner = bar.querySelector('.cart-free-shipping-bar__progress-inner');
    var textEl = bar.querySelector('.cart-free-shipping-bar__text');

    if (progressInner) {
      progressInner.style.transform = 'scaleX(' + progress + ')';
    }

    if (textEl) {
      if (isFreeShipping) {
        textEl.textContent = bar.dataset.textFree || '';
      } else {
        var remainingCents = threshold - requiresShippingTotal;
        var template = bar.dataset.textRemainingTemplate || '';
        textEl.textContent = template.replace('__AMOUNT__', formatMoney(remainingCents));
      }
    }
  }

  function fetchAndUpdateBar() {
    var bar = document.getElementById('CartFreeShippingBar');
    if (!bar) return;

    fetch('/cart.js')
      .then(function(response) { return response.json(); })
      .then(updateBarFromCart)
      .catch(function() {});
  }

  function initFreeShippingBar() {
    var bar = document.getElementById('CartFreeShippingBar');
    if (!bar) return;

    document.addEventListener('cart:updated', function(evt) {
      if (evt.detail && evt.detail.cart) {
        updateBarFromCart(evt.detail.cart);
      } else {
        fetchAndUpdateBar();
      }
    });

    document.addEventListener('ajaxProduct:added', fetchAndUpdateBar);
    document.addEventListener('cart:build', fetchAndUpdateBar);
    document.addEventListener('drawerOpen.CartDrawer', fetchAndUpdateBar);

    fetchAndUpdateBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFreeShippingBar);
  } else {
    initFreeShippingBar();
  }
})();

// Cart drawer state helper
// Keeps a dedicated class on <html> so custom CSS only reacts to the cart drawer,
// not to other theme drawers like search/nav.
(function() {
  'use strict';

  function initCartDrawerStateClass() {
    var root = document.documentElement;
    var cartDrawer = document.getElementById('CartDrawer');

    if (!root || !cartDrawer || typeof MutationObserver === 'undefined') {
      return;
    }

    var syncState = function() {
      root.classList.toggle(
        'pmgw-cart-drawer-open',
        cartDrawer.classList.contains('drawer--is-open')
      );
    };

    syncState();

    var observer = new MutationObserver(syncState);
    observer.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['class']
    });

    document.addEventListener('cart:close', syncState);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawerStateClass);
  } else {
    initCartDrawerStateClass();
  }
})();

